import script from "./Pass.vue?vue&type=script&setup=true&lang=js"
export * from "./Pass.vue?vue&type=script&setup=true&lang=js"

import "./Pass.vue?vue&type=style&index=0&id=79fa09cb&scoped=true&lang=less"

import exportComponent from "C:\\Users\\PC\\AppData\\Local\\Temp\\tecs-enduser-release-cd96384e-20260902-1753\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79fa09cb"]])

export default __exports__